import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import { HomePageBanner } from './HomePageBanner';

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  adaptiveHeight: false,
};

export const HomePageBannerCarousel = ({ banners }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mb: 2
      }}
    >
      <Box
        sx={{
          height: { xs: '150px', md: '200px' },
          width: { xs: '100%', xsm: '100%', mds: '1044px', sm: '1043px', lg: '1308px', xl: '1570px', xxl: '1835px' },
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: '#000',
        }}
      >
        {banners.length === 1 ? (
          <HomePageBanner
            title={banners[0]?.title}
            subTitle={banners[0]?.subTitle}
            bannerImage={banners[0]?.image}
          />
        ) : (
          <Slider {...settings}>
            {banners?.map((banner, index) => (
              <Box key={`banner-key-${index}`} sx={{ height: { xs: '150px', md: '200px' }, overflow: 'hidden' }}>
                <HomePageBanner
                  title={banner?.title}
                  subTitle={banner?.subTitle}
                  bannerImage={banner?.image}
                  withGradient={banner?.withGradient}
                />
              </Box>
            ))}
          </Slider>
        )}
      </Box>
    </Box>
  );
};
